import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { GroupDetailScreen } from './community/group-detail-screen'
import { GroupsScreen } from './community/groups-screen'
import { JoinGroupScreen } from './community/join-group-screen'

export const CommunityScreen = (): React.ReactElement => {
  return (
    <Routes>
      <Route path="join" element={<JoinGroupScreen />} />
      <Route path=":groupId" element={<GroupDetailScreen />} />
      <Route path="*" element={<GroupsScreen />} />
    </Routes>
  )
}
